import $fetch from 'lib/fetch';
import { API_BASE_URL, parseResponseData } from '../../utils';
import { AssociateClientWithSimParams } from './client.requests.types';
import clientResponseSchemas from './client.responses.schemas';

const BASE_SERVICE_URL = `${API_BASE_URL}/client` as const;

export async function getAllClients(params: { keyword?: string }) {
  const { keyword } = params;

  const response = await $fetch(`${BASE_SERVICE_URL}/autocomplete/${keyword}`);

  const data = parseResponseData(response, clientResponseSchemas.getAllClients);

  return data;
}

export async function associateClientWithSim(
  params: AssociateClientWithSimParams
) {
  const response = await $fetch(`${BASE_SERVICE_URL}/associate`, {
    method: 'POST',
    body: JSON.stringify(params),
  });

  const data = parseResponseData(
    response,
    clientResponseSchemas.associateClientWithSim
  );

  return data;
}
